/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Category_Food_DrinkInputs */

const en_gallery_category_food_drink = /** @type {(inputs: Gallery_Category_Food_DrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Food & Drink`)
};

const es_gallery_category_food_drink = /** @type {(inputs: Gallery_Category_Food_DrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comida y bebida`)
};

/**
* | output |
* | --- |
* | "Food & Drink" |
*
* @param {Gallery_Category_Food_DrinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const gallery_category_food_drink = /** @type {((inputs?: Gallery_Category_Food_DrinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Category_Food_DrinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_category_food_drink(inputs)
	return es_gallery_category_food_drink(inputs)
});